<template lang="">
    <div class="row">
        <div class="content__trajet col-lg-8 col-md-12 bilan__ltemp bg-white shadow pb-2">
            <h2 class="text-center m-0 py-3 text-default">
                Bilan des lignes de temps
            </h2>
            <hr class="m-0" />
            <div class="ltemp--content">
                <div class=" mt-3">
                    
                    <div class="row px-md-3">
                         <div class="col-12 col-md-6 col-lg d-flex align-items-center border-primary border border-3 rounded px-2 mr-0 mr-md-2">
                            <input type="text" class="form-control border-0" 
                            placeholder="recherchez par date....." 
                            v-model="searchDate"></input>
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                        <div class="col-12 col-md-6 col-lg my-2 my-md-0 d-flex align-items-center border-primary border rounded px-2 ml-0 ml-md-2">
                            <input type="text" class="form-control border-0" 
                            placeholder="Rechercher par motif de ligne de temps....." 
                            v-model="searchTrajet"></input>
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
                <div class="ltemp--content--box border border-1 px-2 px-md-4 py-2 my-2 mx-md-3 rounded">
                    <div class="trajet__info bg-white mt-2 px-2" v-for="(item, index) in filterTrajet" :key="index">
                    <b-button class="border-0 w-100 h-100 p-0 shadow-none bg-transparent" v-b-modal="'ligne'+index"> 
                        <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                           
                           <span class="d-flex align-items-center text-primary">
                                <i class="fa fa-calendar" aria-hidden="true"></i>
                                <span class="px-1">{{ item.date }}</span>
                            </span>
                            <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="text-default">{{ item.motif }}</span>
                            <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="text-default d-none d-md-block">{{ displayNumber(item.montant) }}</span>
                            <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="text-default d-none d-md-block">{{ item.duree }}</span>
                            <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="">
                                <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary" v-b-modal="'ligne'+index"> 
                                    <span class="d-none d-md-block">Voir</span>
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </b-button> 
                            </span>
                            
                        </div>
                        </b-button> 
                        <b-modal :id="'ligne'+index" size="lg" centered title="Bilan général" hide-footer>
                            <template #modal-header="{ close }">
                                <!-- Emulate built in modal header close button action -->
                                <h4 size="sm" class="modal-title d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                    </svg>
                                    Bilan général
                                </h4>
                                <div class="d-flex align-items-center title-ligne">
                                    <h3 class="text-primary my-0 mx-2 mx-md-5">{{ item.motif }}</h3>
                                    <i class="fa fa-times text-malt mx-2 pt-1" aria-hidden="true" @click="close()"></i>
                                </div>
                            </template>
                            <BilanVersionValidationParLigneTemps :ligne_temps="item" :dossier_medical_slug="dossier_medical_slug"/>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
        <BilanAssure :dossier_medical_slug="dossier_medical_slug" :temps_max_prise_en_charge="temps_max_prise_en_charge" :ligne_temp_length="ligne_temps.length" class="col-md col-12 ml-md-3 mt-2 mt-md-0" />
    </div>
</template>
<script>
import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
import BilanVersionValidationParLigneTemps from './BilanVersionValidationParLigneTemps'
import BilanAssure from './BilanAssure';
import Multiselect from 'vue-multiselect'
import moment from "moment";
import  search  from "@/_services/trajetService";
export default {
    name: "BilanLigneTemp",
    props: ['dossier_medical_slug'],
    components: {
        BilanVersionValidationParLigneTemps,
        BilanAssure,
        Multiselect,
    },
   data() {
        return {
            bilanTotal: 0,
            bilanTotalMedecin: 0,
            bilanTotalAssureur: 0,
            totaux: 0,
            selected: '',
            isVisible: false,
            ligne_temps: [],
            searchTrajet: '',
            searchDate: null,
            motifs: [],
            montants: [],
            montant: null,
            date: '',
            motif: '',
            temps_max_prise_en_charge: 0,
            dates: [],
        }
   },
    methods: {
        displayNumber(value) {
            return Number(value).toLocaleString("fr") + " XAF";
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY");
            } else {
                return date;
            }
        },
        getTotal(data) {
            //console.log("item ", data)
            return data.filter(item => item.etat_validation_souscripteur).reduce((accumulator, validation) => {
                return accumulator + Number(validation.examen_complementaire.prix);
                }, 0);
        },
        getTotalMedecin(data) {
            return data.filter(item => item.etat_validation_medecin).reduce((accumulator, validation) => {
                return accumulator + Number(validation.examen_complementaire.prix);
            }, 0);
        },
        getTotalAssureur(data) {
            let assureurTotal = data.filter(item => item.etat_validation_souscripteur).reduce((accumulator, validation) => {
                return accumulator + Number(validation.examen_complementaire.prix);
            }, 0);
            return assureurTotal;
        },
        getLigneTemps(dossier_medical_slug){
            axios.get(`${AppConfig.apiUrl}/ligne-temps/dossier/${dossier_medical_slug}`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
            .then(res => {

                let ligne_temps = [], totaux = {};
                this.temps_max_prise_en_charge = res.data.temps_max_prise_en_charge;

                res.data.ligne_temps.filter(item => item.validations.length > 0).forEach(timelines => {
                    
                    let motifs = "";
                    if (timelines.hasOwnProperty("motif")) {
                        motifs = timelines.motif.description;
                        if (motifs.length > 105) {
                            motifs = timelines.motif.description.substring(0, 105) + " ...";
                        }
                    }
                    this.bilanTotal += this.getTotal(timelines.validations);
                    this.bilanTotalMedecin += this.getTotalMedecin(timelines.validations);
                    this.bilanTotalAssureur += this.getTotalAssureur(timelines.validations);
                    if(timelines.validations){
                        this.totaux = timelines.validations[0] != null ? timelines.validations[0].version : 0;
                        totaux = timelines.validations[0] != null ? timelines.validations[0].version : null;
                    }
                    ligne_temps.push({
                        id: timelines.id,
                        date: this.formattedDateTime(timelines.created_at),
                        created_at: this.formattedDateTime(timelines.created_at),
                        status: timelines.etat,
                        duree: timelines.duree,
                        motif_date: motifs + " (" + timelines.date_consultation + ")",
                        motif: timelines.motif.description,
                        montant: this.getTotal(timelines.validations),
                        totaux: totaux,
                        validations:timelines,
                    });
                })
                this.ligne_temps = ligne_temps

            })
            .catch((error) => {
                console.log("error ", error)
            });
        }
    },
    mounted() {
        this.getLigneTemps(this.dossier_medical_slug);
    },
    computed: {
    filterTrajet(){
       return search(this.searchTrajet, this.searchDate, this.ligne_temps, this.item)
    },
  }
}
</script>
<style lang="">
    
</style>